import { unitOfMeasureSelectStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";


Object.assign(unitOfMeasureSelectStyles, {
    unitOfMeasureSelect: {
        sizeVariant: "small",
        labelProps: {
            size: TYPOGRAPHY.size.smallest,
            css: css`
                margin-right: 0.5em;
                width: auto;
            `,
        },
        css: css`
            margin-right: 0.6em;
            width: auto;
            /* !important on next 3 lines: Using !important here was chosen to pursue instead of overriding the entirety of the style state on the relevant components. */
            border-radius: 0.5em !important;
            height: 2rem !important;
            border-width: 1px !important;
            font-size: ${TYPOGRAPHY.size.small};
            line-height: ${TYPOGRAPHY.lineHeight.small};
        `
    },
});
